import React, { useEffect, useState } from "react";

import AntDTable from "../AntDTable/AntDTable";

import { Card } from "antd";
import { getScannedFiles } from "../Helpers/API/PatientApi/PatientApi";
import { formatDate } from "../Helpers/Utilities/Common";
import { SeeAttachment } from "../Radiology/SeeAttachment";
import { Col, Row } from "react-bootstrap"

function PatientScannedFiles({ patientId, patientDetails }) {
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);

  // Function get scanned files API
  async function fetchScannedFiles() {
    setShowLoader(true);
    const res = await getScannedFiles({ patient_id: patientId });
    if (res.data) {
      var _parsed = res.data.data.map((file) => {
        return {
          ...file,
          formattedDate: formatDate(file.added_on),
          link: (
            <SeeAttachment
              attachments={[
                { file_url: file.file_url, file_name: file.file_name },
              ]}
            />
          ),
        };
      });
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchScannedFiles();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className="card-with-table">
      <div className="card-table">
        <Row className="align-items-center pb-4 px-2">
          <Col xs={"auto"} className="p-0 align-items-center">
            <h5 className="font-bold">SCANNED FILES</h5>
          </Col>
        </Row>        
        <div className="row justify-content-center">
          <div>
            <AntDTable
              tableHeaders={["UPLOADED ON", "LINK"]}
              headerSelector={["formattedDate", "link"]}
              tableData={data}
              // ActionBtn={(row) => ActionBtn(row.row)}
              // withAction={true}
              loading={showLoader}
              searchExcluded={["link"]}
            />
          </div>
        </div>
      </div>
    </Card>
  );
}

export default PatientScannedFiles;
